<template>
  <div>
    <div v-if="rule" style="width: 80%;margin:0 auto;padding-top: 30px;padding-bottom: 50px;line-height: 40px;">
      <el-col :span="12" class="f-z16" style="font-weight: bold;">
        <span class="text-gradient3">{{ item.title }}</span>
        <span v-if="audit != 3" @click="viewData" style="margin-left: 15px;color: #409EFF;cursor: pointer;font-weight: 100;cursor: pointer">查看数据</span>
        <el-button @click="back" style="margin-left: 10px;">返回</el-button>
      </el-col>
    </div>

    <div style="width: 80%;margin: auto;padding: 10px 0px;color: red;line-height: 16px;">
      <el-row>
        <el-col :span="14">
          预警周期：{{ startDate }} - {{ endDate }}
        </el-col>
        <el-col v-if="replyInfo.auditor" :span="5">
          审阅人： {{ replyInfo.auditor }}
        </el-col>
        <el-col v-if="replyInfo.auditor" :span="5">
          审阅时间： {{ replyInfo.auditTime }}
        </el-col>
      </el-row>
      
    </div>
    <div style="width: 80%;margin: auto;padding: 10px 0px;color: red;line-height: 16px;">
      <el-row>
        <el-col :span="14">
          规则说明：
          <span v-if="item.categoryName == '客流'">
            预算完成率<95%或连续两周【（本期/同期-1）-（月度指标/同期全月-1）】<-5%（跨越星期算作周一所在月份）
          </span>
          <span v-if="item.categoryName == '空铺'">
            【百货类超过30天+租赁类超过45天】的空铺明细
          </span>
          <span v-if="item.categoryName == '毛利率'">
            【（月本期-月预算）】<-0.5%
          </span>
		  <span v-if="item.categoryName == '营收'">
		    预算完成率<95%
		  </span>
		  <span v-if="item.categoryName == '收缴率'">
		    每月21日推送未完成收缴品牌明细
		  </span>
		  <span v-if="item.categoryName == '租售比'">
		    按品牌所属的小品类标准租售比，高于租售比X的作为预警品牌
		  </span>
        </el-col>
        <el-col v-if="replyInfo.auditor" :span="8">
          审阅备注： {{ replyInfo.auditComment }}
        </el-col>
      </el-row>
    </div>
    <div v-if="replyInfo.auditor == null" style="width: 80%;margin: auto;padding: 10px 0px;color: red;line-height: 16px;">
      <el-row v-if="rejectList">
        <el-alert
            title="驳回原因"
            type="warning"
            :description="rejectList.rejectComment"
            show-icon>
        </el-alert>
      </el-row>
    </div>
    <div style="width: 50%; margin: 10px auto;padding: 10px;">
      <form-create
          v-if="rule"
          v-model="fapi"
          :rule="rule"
          :option="option"
          style="text-align:left;"
      >
        <template v-for="(item,index) in slotList" @key="index" :slot="'type-' + item.type" slot-scope="scope">
          <slot-in v-if="audit != 2 && audit != 3" v-bind:key="item.type" v-bind:type-item="item.type" v-bind:file-list-fj="replyInfo.attachment"
                   v-bind:file-list-uf="replyInfo.uploadFile"
                   v-bind:scope="scope.rule" v-bind:form-data="fapi"></slot-in>
          <slot-new v-if="audit == 2 || audit == 3" v-bind:key="item.type" v-bind:type-item="item.type" v-bind:file-list-fj="replyInfo.attachment"
                   v-bind:file-list-uf="replyInfo.uploadFile"
                   v-bind:scope="scope.rule" v-bind:form-data="fapi"></slot-new>         
        </template>
      </form-create>
      <!-- 自定义提交，重置按钮 -->
      <block v-if="audit != 3">
        <el-button v-if="rule && audit != 2 && _hasButtonPermission('提交') && item.status != 4" type="primary" @click="submit" style="margin-left: 125px;" :disabled="type == 1 && item.status != 4 ? true: false">提交</el-button>
        <el-button v-if="rule && audit != 2 && _hasButtonPermission('提交') && item.status != 4" type="reset" @click="reset" :disabled="type == 1 && item.status != 4 ? true: false">重置</el-button>

        <el-button v-if="rule && audit == 2" type="primary" @click="dialogFormAuditVisible = true" style="margin-left: 125px;" :disabled="item.status == 4 ? true : false">审阅确认</el-button>
        <el-button v-if="rule && audit == 2" type="warning" @click="dialogFormRejectVisible = true" style="margin-left: 125px;" :disabled="item.status == 4 ? true : false">驳回</el-button>
      </block>
    </div>

    <el-dialog title="审阅确认" :visible.sync="dialogFormAuditVisible">
      <el-form :model="formIn">
        <el-form-item label="审阅备注" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="formIn.comment" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormAuditVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditSure">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="驳回" :visible.sync="dialogFormRejectVisible">
      <el-form :model="formReject">
        <el-form-item label="驳回原因" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="formReject.comment" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormRejectVisible = false">取 消</el-button>
        <el-button type="primary" @click="rejectSure">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import slotIn from '../../../components/alarm/slot'
import slotNew from '../../../components/alarm/slotNew'
import AlarmOrderApi from "../../../api/alarm/order/AlarmOrderApi";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
import Auth from '../../../util/auth'
import {default as commonIn} from '@/util/common'
export default {
  name: "taskDetails",
  components: {
    slotIn,
    slotNew
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    type: {
      type: Number,
      default: 0
    },
    return: {
      type: Number,
      default: 1
    },
    page: {
      type: Object,
      default: null
    },
    role: {
      type: Number
    },
    audit: {
      type: Number,
      default: 1
    },
    searchData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      slotList: [
        {type: 'upload', is_custom: 0}
      ],
      fapi: {
        store_id: "1"
      },
      rule: '',
      option: '',
      fileList: {},
      replyInfo: {},
      buttonPriviledgeList: [],
      startDate: '',
      endDate: '',
      dialogFormAuditVisible: false,
      dialogFormRejectVisible: false,
      formIn: {
        comment: ''
      },
      formReject: {
        comment: ''
      },
      formLabelWidth: '120px',
      rejectList: {}
    }
  },
  created() {
    this.getButtonPriviledge()
  },
  mounted() {
    console.log(this.item)
    console.log(this.audit)
    this.getRejectInfo()
    if (this.type == '1') {
      // 获取回复值
      this.getReply()
    } else {
      this.getTemplate()
    }
    let taskType  = this.item.isDouble == 1 ? 3 : this.item.taskType
    let dateArr = commonIn.getAlarmCycle({date: this.item.createDate, type: taskType})
    this.startDate = dateArr[0]
    this.endDate = dateArr[1]
  },
  methods: {
    // 审阅确认
    auditSure() {
      let that = this
      console.log(this.formIn.comment)
      let params = {
        taskId: this.item.id,
        comment: this.formIn.comment
      }
      AlarmOrderApi.taskAudit(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.dialogFormAuditVisible = false
          alert('操作成功')
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 驳回确认
    rejectSure() {
      let that = this
      let params = {
        taskId: this.item.id,
        comment: this.formReject.comment
      }
      AlarmOrderApi.taskReject(params).then(res => {
        res = res.data
        if (res.code == 200) {
          alert('操作成功')
          that.dialogFormRejectVisible = false
          that.item.status = 4
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 查看详细数据
    viewData() {
      let item = this.item

      this.$emit("addCallbackMsg", {formStatus:'msg', item: item, audit: this.audit, type: this.type, turnType: 1})
    },
    // 获取回复
    async getReply() {
      let that = this
      await AlarmOrderApi.getReply({taskId: this.item.id}).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200 && res.data) {
          that.replyInfo = res.data
          that.replyInfo.attachment = that.replyInfo.attachment != '' ? JSON.parse(that.replyInfo.attachment) : ''
          that.replyInfo.uploadFile = that.replyInfo.uploadFile != '' ? JSON.parse(that.replyInfo.uploadFile) : ''
          that.replyInfo.auditTime = that.replyInfo.auditTime != null ? that.timeFormatSeconds(that.replyInfo.auditTime) : ''
          console.log(that.replyInfo)
          that.getTemplate()
        } else {
          that.getTemplate()
        }
      })
    },
    // 获取任务驳回记录
    async getRejectInfo() {
      let that = this
      await AlarmOrderApi.getRejectInfo({taskId: this.item.id}).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200 && res.data) {
          console.log(res.data)
          that.rejectList = res.data
        } else {
          console.log(res)
        }
      })
    },
    // 时间戳转换
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hours = d.getHours();
      var min = d.getMinutes();
      var seconds = d.getSeconds();

      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;
      if (hours < 0) hours = '0' + hours;
      if (min < 10) min = '0' + min;
      if (seconds < 10) seconds = '0' + seconds;

      return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
    },
    // 任务提交
    submit() {
      let that = this
      this.fapi.submit((formData, fapi) => {
        let params = formData
        params.attachment = JSON.stringify(params.attachment)
        params.upload_file = JSON.stringify(params.upload_file)
        params.taskId = that.item.id
        params.deptId = that.item.positionDeptId
        params.roleId = that.page.roleId

        // 计算处理时长
        let today = new Date()
        let deal = new Date(that.item.createDate)
        let ended = new Date(that.item.overTime);
        // 判断是否逾期
        if ((today - ended) < 0) {
          params.isOver = 1
        }
        let usedTime = (today - deal)
        console.log(usedTime)
        let dealDuration = Math.floor(usedTime/(3600*1000));
        params.dealDuration = dealDuration

        console.log(params)
        AlarmOrderApi.taskSubmit(params).then(res => {
          console.log(res)
          res = res.data
          if (res.code == 200) {
            alert('提交成功')
            that.$emit("back", {formStatus: 'list'})
          } else {
            alert(res.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      })
    },
    // 返回
    back() {
      if (this.return == 1) {
        this.$emit("back", {formStatus: 'list'})
      } else if (this.return == 2) {
        this.$emit("addCallbackTaskList", {formStatus:'taskList', item: this.item, searchData: this.searchData})
      }
    },
    // 重置
    reset() {
      this.fapi.resetFields()
    },
    // 获取模板
    getTemplate() {
      let that = this
      let params = {
        templateId: 1
      }
      AlarmOrderApi.getTemplateDetail(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          let data = res.data
          let rules = JSON.parse(data.rules)
          rules.map(item => {
            console.log(item)
            if (item.field == "replay" && that.replyInfo.reply) {
              item.value = that.replyInfo.reply
              item.props.readonly = true
            }
            if (item.field == "descrip" && that.replyInfo.descrip) {
              item.value = that.replyInfo.descrip
              item.props.readonly = true
            }
            if (item.type == 'upload') {
              that.fileList[item.field] = []
              item.props.headers = {
                "HC-SMP-Authorization": Auth.getAccessToken()
              }
              item.props.data = {
                "fieldName": item.field,
                "path": '/alarm/order/'
              }
            }
          })
          console.log(rules)
          that.rule = rules
          that.option = JSON.parse(data.options)
          that.option.submitBtn = false
        }
      })
    },

    getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
  .text-gradient3 {
    background-image: linear-gradient(to right, #ffec3d, #d4b106);
    -webkit-background-clip: text;
    color: transparent;
  }
  .f-z16 {
    font-size: 15px;
  }
</style>